import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { HeroSlideItem, PresentationSlideItem } from '../../home.models';

@Component({
  selector: 'app-home-presentation-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './presentation-section.component.html'
})
export class PresentationSectionComponent {
  @ViewChild('chartsPresentation') chartsPresentation!: ElementRef<HTMLElement>;

  @Input({ required: true }) presentationSlides: PresentationSlideItem[] = [];
  @Input({ required: true }) presentationHero!: HeroSlideItem;
  @Input() activePresentationIndex = 0;
  @Input() heroTrackerRotateX = '0deg';
  @Input() heroTrackerRotateY = '0deg';
  @Input() heroTrackerOffsetX = '0px';
  @Input() heroTrackerOffsetY = '0px';
  @Input() heroTrackerGlowX = '50%';
  @Input() heroTrackerGlowY = '50%';
  @Input({ required: true }) presentationStepLabel!: (index: number) => string;

  @Output() presentationSlideRequested = new EventEmitter<number>();
  @Output() heroTrackerMove = new EventEmitter<MouseEvent>();
  @Output() heroTrackerLeave = new EventEmitter<void>();
}
